// in src/posts.js
import React from 'react';
import {SelectField, BooleanField, ImageField, ImageInput, DeleteButton, BooleanInput, ShowButton, DateField, RichTextField, Show, SimpleShowLayout, SimpleList, Filter, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';

import Dropzone from 'react-dropzone'
import { RichTextInput } from 'ra-input-rich-text';
import InputUploadInput from '../mui/field/UploadInput';
import { OnlyShowActionsList, OnlyShowActionsEdit, DontDeletectionsDetail } from './FieldComponents/OnlyShowActions';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const PageFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="title" alwaysOn />
    </Filter>
);

export const PageList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} filters={<PageFilter />} title="Listar Páginas" actions={<OnlyShowActionsList />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.title}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="title" label="Título" />
                    <TextField source="page" label="Página ID" />
                    <ImageField source="image" label="Imagen" />
                    <BooleanField source="state" label="Estado" />
                    <BooleanField source="sub_page" label="Sub Página" />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            )}
        </List>
    );
};

const PageTitle = ({ record }) => {
    return <span>Página {record ? `"${record.title}"` : ''}</span>;
};

const choices = [
    { id: 123, first_name: 'Leo', last_name: 'Tolstoi' },
    { id: 456, first_name: 'Jane', last_name: 'Austen' },
    ];
    const optionRenderer = choice => `${choice.first_name} ${choice.last_name}`;

export const PageEdit = (props) => (
    <Edit title={<PageTitle />} {...props} actions={<OnlyShowActionsEdit />}>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <InputUploadInput source="image" label="Imagen" validate={[Validators.required]}/>
            <RichTextInput source="description" label="Descripción" validate={[Validators.required]}/>
            <TextInput source="page" label="Página ID" disabled/>
            <BooleanInput label="Estado" source="state" />
        </SimpleForm>
    </Edit>
);

export const PageCreate = (props) => (
    <Create {...props} title="Crear Página">
        <SimpleForm>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <InputUploadInput source="image" label="Imagen" validate={[Validators.required]}/>
            <RichTextInput source="description" label="Descripción" validate={[Validators.required]}/>
            <TextInput source="page" label="Página ID" validate={[Validators.required]} />
            <BooleanInput label="Estado" source="state" defaultValue={true} />
        </SimpleForm>
    </Create>
);

export const PageShow = (props) => (
    <Show title={<PageTitle />} {...props} actions={<DontDeletectionsDetail />}>
        <SimpleShowLayout>
            <TextField source="title" label="Título"/>
            <RichTextField source="description" label="Descripción"/>
            <ImageField source="image" label="Imagen"/>
            <TextField source="page" label="Página ID"/>
            <BooleanField source="state" label="Estado"/>
            <DateField label="Fecha Actualización" source="updatedAt" />
            <DateField label="Fecha Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
